export const createIdFromSlugAndId = (name?: string, id?: number) =>
  `${name?.toLocaleLowerCase().replace(/\s/g, '-')}-${id}`
